<template>
  <v-container fluid class="pa-10">
    <v-row justify="end">
      <v-col align="start" align-self="center">
        <v-btn
          icon
          class="hidden-xs-only mb-2"
          color="primary"
          @click="$router.push('/dashboard')"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="text-h5 text-center bold ml-4">DECLARAÇÕES</span>
        <v-row class="pt-3"> </v-row>
      </v-col>
      <v-col cols="auto" align="end" align-self="center" justify="center">
        <v-dialog v-model="visible" max-width="700px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              rounded
              large
              color="primary"
              v-on="on"
              @click="onClickViewSignature"
            >
              <v-icon style="margin-right: 5px">mdi-eye</v-icon>
              Assinatura
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">Visualizar assinatura</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row justify="center" no-gutters>
                  <v-col cols="12">
                    <p v-if="teachingCoordinatorName" justify="center">
                      A assinatura cadastrada é referente ao
                      <b>COORDENADOR DOCENTE</b> denominado(a)
                      {{ teachingCoordinatorName }}.
                    </p>
                    <p v-else justify="center" style="color: red">
                      A assinatura cadastrada <b>NÃO</b> é referente a nenhum
                      <b>COORDENADOR DOCENTE</b>! Por favor, atribua um
                      <b>COORDENADOR DOCENTE</b> para a assinatura atual para
                      poder seguir com a declaração.
                    </p>
                    <p justify="center">
                      Para alterar o cadastro, clique no botão
                      <b>TROCAR ASSINATURA</b> e selecione a nova assinatura a
                      ser utilizada nas declarações ou mude a foto inserida na
                      pasta <b>ASSINATURA</b> do Google Drive.
                    </p>
                    <p justify="center">
                      Para alterar o usuário referente a assinatura, clique no
                      botão
                      <b>TROCAR USUÁRIO</b> e selecione o novo usuário que será
                      utilizado nas declarações.
                    </p>
                    <p justify="center">
                      <b
                        >Aviso: Selecionar o usuário REFERENTE a ASSINATURA
                        significa que este usuário será o responsável que estará
                        declarando as declarações, então sempre CONFIRA se a
                        ASSINATURA é REFERENTE ao USUÁRIO selecionado.
                      </b>
                    </p>
                  </v-col>
                  <v-col cols="12" justify="center" align="center">
                    <div v-if="signature.url" style="border: 1px solid black">
                      <img :src="signature.url" height="70" />
                    </div>
                  </v-col>
                  <v-col cols="12" class="mt-5" align="center">
                    <input
                      ref="uploader"
                      class="d-none"
                      type="file"
                      accept="image/*"
                      @change="onFileChanged"
                    />

                    <v-btn large color="primary" @click="onButtonClick">
                      <v-icon class="mr-2">mdi-pencil</v-icon>
                      Trocar assinatura
                    </v-btn>
                  </v-col>

                  <v-col cols="12" class="mt-5" align="center">
                    <v-dialog
                      v-model="modalChangeUserSignature"
                      persistent
                      :max-width="$vuetify.breakpoint.mdAndDown ? '' : '70vw'"
                    >
                      <template
                        v-slot:activator="{ on: onDialog, attrs: attrsDialog }"
                      >
                        <v-btn
                          large
                          color="primary"
                          v-bind="attrsDialog"
                          v-on="onDialog"
                          @click="onChangeUserSignature"
                        >
                          <v-icon class="mr-2">mdi-account</v-icon>
                          Trocar usuário
                        </v-btn>
                      </template>
                      <v-card>
                        <v-toolbar color="primary" dark
                          >Coordenadores Docentes</v-toolbar
                        >
                        <v-card-text>
                          <br />
                          <p>
                            *Selecione o usuário referente a assinatura atual.
                          </p>

                          <v-data-table
                            class="mt-12"
                            item-key="id"
                            :headers="headersTeachingCoordinator"
                            :items="teachingCoordinators"
                          >
                            <template v-slot:[`item.actions`]="{ item }">
                              <v-tooltip
                                v-if="!item.teachingCoordinator.signature"
                                top
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="!item.teachingCoordinator.signature"
                                    :disabled="loadingUserChangeSignature"
                                    icon
                                    large
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="onSelectUser(item)"
                                  >
                                    <v-icon> mdi-check </v-icon>
                                  </v-btn>
                                </template>
                                <span>Selecionar usuário</span>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closeModalChangeUserSignature"
                          >
                            Fechar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="cancel"> Fechar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-card class="pa-6 mt-10">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="12" md="3" lg="3" xl="3">
            <v-select
              v-model="form.type"
              :items="types"
              label="Tipo de Declaração"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type !== 3" cols="12" sm="12" md="4" lg="4" xl="4">
            <v-select
              v-model="form.user"
              :items="formattedUsers"
              label="Usuário"
              outlined
              required
              :rules="stringRules"
              dense
              @change="setUser"
            />
          </v-col>
          <v-col
            v-if="form.type === 1 || form.type === 4"
            cols="12"
            sm="12"
            md="2"
            lg="2"
            xl="2"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.period"
                  label="Período"
                  outlined
                  dense
                  required
                  :rules="stringRules"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="periodo" range />
            </v-menu>
          </v-col>
          <v-col
            v-if="form.type === 1 || form.type === 4"
            cols="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
          >
            <v-text-field
              v-model="form.hours"
              label="Horas"
              suffix="horas"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 1" cols="12" sm="12" md="6" lg="6" xl="6">
            <v-textarea
              v-model="form.obs"
              outlined
              dense
              label="Atividades realizadas"
              hint="Este texto será inserido após o 'a saber', especificando quais atividades foram realizadas."
              persistent-hint
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 3" cols="12" sm="12" md="2" lg="2" xl="2">
            <v-text-field
              v-model="form.numeroOficio"
              label="Número do Ofício"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 3" cols="12" sm="12" md="3" lg="3" xl="3">
            <v-text-field
              v-model="form.quantidade"
              label="Quantidade"
              suffix="unidades"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 3" cols="12" sm="12" md="3" lg="3" xl="3">
            <v-text-field
              v-model="form.valorEstimado"
              label="Valor Estimado"
              prefix="R$"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 3" cols="12" sm="12" md="3" lg="3" xl="3">
            <v-text-field
              v-model="form.areaFonte"
              label="Área e Fonte"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 3" cols="12" sm="12" md="3" lg="3" xl="3">
            <v-text-field
              v-model="form.destinatario"
              label="Destinatário"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 3" cols="12" sm="12" md="3" lg="3" xl="3">
            <v-text-field
              v-model="form.cargoDestinatario"
              label="Cargo do Destinatário"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
          <v-col v-if="form.type === 4" cols="12" sm="12" md="3" lg="3" xl="3">
            <v-text-field
              v-model="form.liderGepep"
              label="Líder do GEPEP"
              outlined
              dense
              required
              :rules="stringRules"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-row class="mt-6">
      <v-col align="center">
        <v-btn
          class="mr-5"
          large
          rounded
          color="secondary"
          @click="$router.push('/users')"
        >
          Cancelar
        </v-btn>
        <v-btn large rounded color="primary" @click="generateReport">
          <v-icon class="pr-3">mdi-pencil</v-icon>
          Gerar declaração
        </v-btn>
      </v-col>
    </v-row>

    <div>
      <VueHtml2pdf
        ref="html2Pdf"
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`${
          types.find((x) => x.value === form.type)
            ? types.find((x) => x.value === form.type).text
            : ''
        } - ${user.fullName}`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
      >
        <section slot="pdf-content" class="content">
          <img
            :src="require('@/assets/img/logo.png')"
            width="130"
            style="margin-right: 100px; margin-left: 10px"
          />
          <span v-if="form.type !== 3" style="font-size: 25px"
            ><b>Declaração de Participação</b></span
          >
          <br v-if="form.type !== 3" /><br v-if="form.type !== 3" />

          <!-- Declaração de Participação -->
          <p
            v-if="form.type === 1"
            justify="center"
            style="padding: 20px; line-height: 1.5; font-size: 16px"
          >
            Declaro para os devidos fins que,
            <b
              >{{ user.fullName }}, inscrito(a) no CPF {{ user.cpf }}, RG
              {{ user.rg }}
              <span
                v-if="
                  user.teachingCoordinator &&
                  user.teachingCoordinator.registerNumber
                "
              >
                , número de registro
                {{ user.teachingCoordinator.registerNumber }}
              </span>
              <span
                v-if="user.studentCoordinator && user.studentCoordinator.ra"
              >
                , RA
                {{ user.studentCoordinator.ra }}
              </span>
            </b>

            <span v-if="user.monitor && user.monitor.course">
              , aluno(a) regularmente matriculada no curso de
              {{ user.monitor.course }}

              <span v-if="user.monitor.period">
                , no período {{ user.monitor.period }}
              </span>
            </span>
            , participou como
            <span
              >{{
                profilesOptions.find((x) => x.value === user.profileId)
                  ? profilesOptions.find((x) => x.value === user.profileId).text
                  : ''
              }} </span
            >das atividades do PEJA – Projeto de Educação de Jovens e Adultos da
            Faculdade de Ciências Unesp – Campus Bauru, no período de
            {{ form.period }}, a saber: {{ form.obs }}, totalizando
            {{ form.hours }} horas.
          </p>

          <p
            v-else-if="form.type === 2"
            justify="center"
            style="padding: 20px; line-height: 1.5; font-size: 16px"
          >
            Declaro para os devidos fins que {{ user.fullName }}, portador do
            CPF {{ user.cpf }} é
            <span
              >{{
                profilesOptions.find((x) => x.value === user.profileId)
                  ? profilesOptions.find((x) => x.value === user.profileId).text
                  : ''
              }}
            </span>
            inscrito(a) no Projeto de Extensão Universitária “PEJA – Projeto de
            Educação de Jovens e Adultos”, participando das aulas de
            Alfabetização e dos conteúdos do ENCCEJA – Exame Nacional para
            Certificação de Competências de Jovens e Adultos, com aulas na
            UNESP- Câmpus/Bauru.
          </p>

          <p
            v-else-if="form.type === 4"
            justify="center"
            style="padding: 20px; line-height: 1.5; font-size: 16px"
          >
            Declaro para os devidos fins que {{ user.fullName }} participou das
            reuniões do Grupo de Estudos e Pesquisas em Educação Popular –
            GEPEP, cadastrado no CNPq, e certificado pela UNESP, com reuniões
            quinzenais da Faculdade de Ciências, UNESP Campus de Bauru, no
            período de {{ form.period }}, contando com {{ form.hours }} horas.
          </p>

          <p
            v-if="form.type !== 3"
            style="margin-left: 450px; margin-top: 300px"
          >
            {{ new Date().toLocaleDateString('pt-Br', { dateStyle: 'full' }) }}
          </p>

          <!-- OFICIO -->
          <p v-if="form.type === 3" style="margin-left: 450px">
            {{ new Date().toLocaleDateString('pt-Br', { dateStyle: 'full' }) }}
          </p>

          <p
            v-if="form.type === 3"
            justify="center"
            style="padding: 20px; line-height: 1.5; font-size: 16px"
          >
            <b
              >Ofício: {{ form.numeroOficio }} <br />
              <i>Ref. Aquisição de vale transporte</i></b
            >
          </p>

          <p
            v-if="form.type === 3"
            justify="center"
            style="padding: 20px; line-height: 1.5; font-size: 16px"
          >
            Prezado(a) senhor(a),
          </p>

          <p
            v-if="form.type === 3"
            justify="center"
            style="padding: 20px; line-height: 1.5; font-size: 16px"
          >
            Solicitamos a compra de {{ form.quantidade }} unidades de vale
            transporte para o desenvolvimento do Projeto de Educação de Jovens e
            Adultos - PEJA, no valor estimado de R$ {{ form.valorEstimado }},
            disponível para utilização no SISADM com área e fonte denominados
            {{ form.areaFonte }}.
          </p>

          <div v-if="signature.pdfUrl && form.type === 3">
            <p style="margin-left: 300px; margin-top: 200px">Atenciosamente,</p>
            <img
              :src="signature.pdfUrl"
              height="70"
              style="margin-left: 300px"
            />

            <p style="margin-left: 150px">
              {{ teachingCoordinatorName }} (COORDENADOR(A) LOCAL DO PEJA BAURU)
            </p>
          </div>

          <p
            v-if="form.type === 3"
            style="
              padding: 20px;
              line-height: 1.5;
              font-size: 16px;
              margin-top: 100px;
            "
          >
            A Ilmo(a);<br />
            <i>{{ form.destinatario }}</i
            ><br />
            <i
              ><b>{{ form.cargoDestinatario }}</b></i
            >
          </p>

          <div v-if="signature.pdfUrl && form.type < 3">
            <img
              :src="signature.pdfUrl"
              height="70"
              style="margin-left: 300px; margin-top: 200px"
            />

            <p style="margin-left: 150px">
              {{ teachingCoordinatorName }} (COORDENADOR(A) LOCAL DO PEJA BAURU)
            </p>
          </div>

          <div v-if="signature.pdfUrl && form.type === 4">
            <p style="margin-left: 200px; margin-top: 200px">
              _____________________________________________
            </p>

            <p style="margin-left: 250px">
              {{ form.liderGepep }}
            </p>

            <p style="margin-left: 300px">(LÍDER DO GEPEP)</p>
          </div>
        </section>
      </VueHtml2pdf>
    </div>
  </v-container>
</template>

<script>
/* eslint-disable import/no-cycle */

import VueHtml2pdf from 'vue-html2pdf';
import { mapActions } from 'vuex';
import { profilesOptions } from '../utils/Profiles';

import { getFiles, sendFile, deleteFile } from '@/services/file';

import { getUsers, getTeachingCoordinatorsAndAdmins } from '@/services/user';
import {
  getUserHasSignature,
  updateUserSignature,
} from '@/services/certificate';

import { mimeType } from '@/utils/MimeType';
import { stringRules } from '@/utils/Rules';

export default {
  name: 'Certificates',
  components: {
    VueHtml2pdf,
  },
  data: () => ({
    modalChangeUserSignature: false,
    profilesOptions,
    stringRules,
    signatureFolderId: '',
    mimeType,
    folders: [],
    items: [],
    signature: {
      url: '',
      id: '',
    },
    dialog: false,
    visible: false,
    loadingUserChangeSignature: false,
    teachingCoordinatorName: '',
    teachingCoordinators: [],
    headersTeachingCoordinator: [
      {
        text: 'Nome',
        align: 'start',
        filterable: true,
        value: 'firstName',
        class: 'primary',
      },
      {
        text: 'Sobrenome',
        align: 'start',
        filterable: true,
        value: 'lastName',
        class: 'primary',
      },
      {
        text: 'CPF',
        align: 'start',
        filterable: true,
        value: 'cpf',
        class: 'primary',
      },
      {
        text: 'Perfil',
        align: 'start',
        filterable: true,
        value: 'profile.description',
        class: 'primary',
      },
      { text: 'Ações', value: 'actions', sortable: false, class: 'primary' },
    ],
    selectedFile: '',
    formattedUsers: [],
    types: [
      {
        text: 'Declaração Padrão',
        value: 1,
      },
      {
        text: 'Declaração Passe de Ônibus',
        value: 2,
      },
      {
        text: 'Ofício Vale Transporte',
        value: 3,
      },
      {
        text: 'Declaração GEPEP',
        value: 4,
      },
    ],
    form: {
      user: '',
      profileId: '',
      name: '',
      period: `${new Date().toLocaleDateString()} - ${new Date().toLocaleDateString()}`,
      obs: '',
      hours: '',
      type: 1,
    },
    valid: false,
    users: [],
    user: {},
    menu: false,
    periodo: [],
  }),
  watch: {
    periodo() {
      if (!this.periodo || !this.periodo[0] || !this.periodo[1]) return null;

      const [initialYear, initialMonth, initialDay] =
        this.periodo[0].split('-');

      const formattedInicialDate = new Date(
        initialYear,
        initialMonth,
        initialDay
      ).toLocaleDateString();

      const [finalYear, finalMonth, finalDay] = this.periodo[1].split('-');

      const formattedFinalDate = new Date(
        finalYear,
        finalMonth,
        finalDay
      ).toLocaleDateString();

      this.form.period = `${formattedInicialDate} a ${formattedFinalDate}`;
    },
  },
  mounted() {
    this.getSignatureFolderId();
    this.getUsers();
    this.setCoordinatorWIthSignature();
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async setCoordinatorWIthSignature() {
      const response = await getUserHasSignature();
      if (response && response.success) {
        this.teachingCoordinatorName = response.data
          ? `${
              response.data.firstName
                ? response.data.firstName.toUpperCase()
                : ''
            } ${
              response.data.lastName ? response.data.lastName.toUpperCase() : ''
            }`
          : '';
      }
    },
    async onClickViewSignature() {
      await this.setCoordinatorWIthSignature();
    },
    async getSignatureFolderId() {
      try {
        this.showLoading();
        const resultado = await getFiles({
          parents: '',
          nameContains: 'assinatura',
        });

        const data = resultado.data.map((x) => {
          const icon = this.mimeType.find((z) => z.accept.includes(x.mimeType));
          return {
            ...x,
            icon: icon ? icon.svg : 'others',
          };
        });

        this.folders = data.filter((f) => f.icon === 'folder');

        if (this.folders.length > 0) {
          this.signatureFolderId = this.folders[0].id;

          const resultadoItem = await getFiles({
            parents: this.signatureFolderId,
            nameContains: '',
          });

          const dataItem = resultadoItem.data.map((x) => {
            const icon = this.mimeType.find((z) =>
              z.accept.includes(x.mimeType)
            );
            return {
              ...x,
              icon: icon ? icon.svg : 'others',
            };
          });

          this.items = dataItem.filter((f) => f.icon !== 'folder');

          this.signature.url =
            this.items && this.items.length > 0
              ? `https://drive.google.com/uc?export=view&id=${this.items[0].id}`
              : '';

          this.signature.pdfUrl =
            this.items && this.items.length > 0
              ? this.items[0].thumbnailLink
              : '';

          this.signature.id =
            this.items && this.items.length > 0 ? this.items[0].id : '';
        }
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar arquivos.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    generateReport() {
      const isValid = this.$refs.form.validate();
      if (!this.teachingCoordinatorName) {
        this.$root.vtoast.show({
          message:
            'Por favor, selecione um usuário REFERENTE a ASSINATURA clicando no botão ASSINATURA.',
          top: true,
          left: true,
          show: true,
          color: 'info',
          icon: 'mdi-exclamation-thick',
          timer: 5000,
        });
        return;
      }
      if (isValid) {
        this.$refs.html2Pdf.generatePdf();
      }
    },
    cancel() {
      this.visible = false;
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      /* eslint-disable */
      try {
        await this.removeFile();
        this.showLoading();
        const formData = new FormData();
        this.selectedFile = e.target.files[0];

        const type = this.selectedFile.name.split('.').pop();

        formData.append('file', this.selectedFile);
        formData.append('folder', this.signatureFolderId);
        await sendFile(formData);

        this.$root.vtoast.show({
          message: `Arquivo ${this.selectedFile.name} adicionado com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });

        this.getSignatureFolderId();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao salvar o arquivo.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    async removeFile() {
      if (this.signature.id) {
        try {
          this.showLoading();
          const resultado = await deleteFile({
            filesIds: [this.signature.id],
          });
          this.$root.vtoast.show({
            message: `Arquivo excluído com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
        } catch (e) {
          this.$root.vtoast.show({
            message: 'Erro ao excluir o arquivo.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } finally {
          this.hideLoading();
        }
      }
    },
    async getUsers() {
      try {
        this.showLoading();
        const { data } = await getUsers(this.form);

        this.users = data.rows;
        this.formattedUsers = this.users.map((x) => {
          return {
            text: x.fullName,
            value: x.id,
          };
        });
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar usuários.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    setUser() {
      const el = this.users.find((x) => x.id === this.form.user);

      this.user = {
        ...el,
        fullName: `${el.firstName} ${el.lastName}`,
      };
    },
    async onChangeUserSignature() {
      const response = await getTeachingCoordinatorsAndAdmins();
      if (response && response.success && response.data) {
        this.modalChangeUserSignature = true;
        this.teachingCoordinators = response.data;
      } else {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar usuários.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      }
    },
    closeModalChangeUserSignature() {
      this.modalChangeUserSignature = false;
    },
    async onSelectUser(coordinator) {
      this.loadingUserChangeSignature = true;

      if (
        coordinator &&
        coordinator.teachingCoordinator &&
        coordinator.teachingCoordinator.id
      ) {
        const response = await updateUserSignature(
          coordinator.teachingCoordinator.id
        );
        if (response && response.success && response.data) {
          if (this.$root.vtoast) {
            this.$root.vtoast.show({
              message: 'Usuário selecionado com sucesso.',
              top: true,
              right: true,
              show: true,
              color: 'success',
            });
          }
          await this.onChangeUserSignature();
          await this.setCoordinatorWIthSignature();
        }
        this.loadingUserChangeSignature = false;
        return;
      }
      if (this.$root.vtoast) {
        this.$root.vtoast.show({
          message: 'Erro ao selecionar usuário referente a assinatura.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      }
      this.loadingUserChangeSignature = false;
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.content {
  padding: 15px;
}

.container-pdf {
  margin: 25px;
  width: 350px;
  height: 200px;
  display: flex;
  justify-content: center;
}

.img-container {
  text-align: center;
  display: block;
}
</style>
